export default ({ data: { error } }) =>
  error &&
  error.graphQLErrors &&
  error.graphQLErrors.length > 0 &&
  error.graphQLErrors[0].extensions &&
  error.graphQLErrors[0].extensions.code === 'FORBIDDEN';
